<template>
  <b-card class="text-center task-card" :class="{ completed: item.complete, 'item-selected': allSelect }">
    <template slot="header" class="mb-0" @click="alert('a')">
      <div v-if="!external" class="check-section">
        <b-form-checkbox class="ticket-checkbox"  v-model="item.complete" @click.native.stop @change="flipStatus(item)"></b-form-checkbox>
      </div>
      <div class="task-text-wrapper">
        <template v-if="external">
          <span class="task-text">{{item.text}}</span>
        </template>
        <template v-else>
          <span @dblclick="textEdit=!textEdit" v-show="!textEdit" class="task-text cp">{{item.text}}</span>
          <b-form-textarea v-show="textEdit" v-model="item.text" @dblclick="textEdit=!textEdit" @input="updateText(item)" />
          <span><fa v-show="textEdit" @click="textEdit=false" icon="times-circle"/></span>
        </template>
      </div>
      <span v-if="!external" class="task-actions">
        <a href="#" @click="fullSelect(item)" class="edit-icons" v-b-tooltip.hover title="Select Task"><span><fa icon="hand-pointer" /></span></a>
        <a href="#" @click="showTaskModal()" class="edit-icons" v-b-tooltip.hover title="Edit Task"><span><fa icon="pen" /></span></a>
        <a href="#" @click="cloneTask()" class="edit-icons" v-b-tooltip.hover title="Clone Task"><span><fa icon="clone" /></span></a>
        <a v-if="item.documentation_link" :href="item.documentation_link" v-b-tooltip.hover title="View docs" target="_blank"><fa icon="question-circle"/></a>
      </span>
    </template>
    <div v-if="external" class="row">
      <div class="col">
        <div class="table-client">
          <span v-if="item.client">{{item.client.name}}</span>
          <span v-else>Not Set</span>
        </div>
      </div>
      <div class="col">
        <div class="table-status">
          <span>{{item.status}}</span>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="table-notes table-notes-field" @click="notesExpand">
          <span>{{item.client_notes}}</span>
        </div>
      </div>
    </div>
    <div v-else class="row">
      <div class="col">
        <span><fa v-show="prioritySelect" @click="prioritySelect=false" icon="times-circle"/></span>
        <div v-b-tooltip.hover :title="`Priority ${item.priority}`" @dblclick="prioritySelect=true" v-show="!prioritySelect" class="priority-dot" :class="`${statusColor(item.priority)} cp`"></div>
        <b-form-select v-show="prioritySelect" v-model="item.priority" @change="updatePriority($event,item)" :options="item.priorities" required />
        <span v-show="!prioritySelect" v-b-tooltip.hover.bottom :title="item.priority"></span>
        <span v-if="item.due_date" class="due-date">Due: {{item.due_date}}</span>
      </div>
      <div class="col" @dblclick="ownerEdit">
        <div v-show="editOwner" class="single-user-selector cp">
          <SingleUserSelector v-on:user-change="updateOwner($event, item)" :parent="item" :parentPath="'task'"/>
          <span><fa v-show="editOwner" @click="editOwner=false" icon="times-circle"/></span>
        </div>
          <img v-show="!editOwner" class="task-user-logo cp" :src="item.owner.avatar_url" v-b-tooltip.hover :title="item.owner.full_name">
      </div>
      <div class="col">
        <div class="table-client cp" @dblclick="clientSelect=true">
          <v-select v-show="clientSelect" v-model="item.client_object" @input="updateClient()" :options="clients" placeholder="Select a client" required />
          <span><fa v-show="clientSelect" @click="clientSelect=false" icon="times-circle"/></span>
          <div v-show="!clientSelect">
            <span v-if="item.client">{{item.client.name}}</span>
            <span v-else v-b-tooltip.hover title="Set Client">Not Set</span>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="table-status cp" @dblclick="editStatus = true">
          <b-form-select v-show="editStatus" v-model="item.status" @change="updateStatus($event,item)" :options="item.statuses" required />
          <span><fa v-show="editStatus" @click="editStatus=false" icon="times-circle"/></span>
          <div v-show="!editStatus">
            {{item.status}}
          </div>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="table-notes table-notes-field" @click="notesExpand" @dblclick="notesEdit = true">
          <b-form-textarea v-show="notesEdit" v-model="item.team_notes" @input="updateTeamNotes(item)" />
          <span><fa v-show="notesEdit" @click="notesEdit=false" icon="times-circle"/></span>
          <div v-show="!notesEdit">
            {{item.team_notes}}
          </div>
          <div v-show="!item.team_notes && !notesEdit" @dblclick="notesEdit = true">
            <b-form-textarea class="cp" placeholder="notes" disabled/>
          </div>
        </div>
      </div>
    </div>
  </b-card>
</template>
<script>
import _ from 'lodash'
import { collectionsMixins } from '@/mixins/collectionsMixins'
import { mapGetters } from 'vuex'
import SingleUserSelector from './selectors/users/SingleUserSelector.vue'
export default {
  name: 'TaskItem',
  mixins: [collectionsMixins],
  components: {
    SingleUserSelector
  },
  props: {
    task: Object,
    selectedTasks: Array,
    external: Boolean
  },
  data () {
    return {
      item: {},
      editOwner: false,
      editStatus: false,
      clientSelect: false,
      notesEdit: false,
      textEdit: false,
      prioritySelect: false,
      allSelect: false
    }
  },
  created () {
    this.initTask()
  },
  computed: {
    ...mapGetters(['clients'])
  },
  methods: {
    initTask () {
      this.item = this.task
      this.editOwner = false
      this.editStatus = false
      this.clientSelect = false
      this.notesEdit = false
      this.textEdit = false
      this.prioritySelect = false
    },

    showTaskModal () {
      this.$root.$emit('taskEdit', this.item)
    },

    cloneTask () {
      let clonedTask = Object.assign({}, this.item)
      clonedTask.clone = true
      delete clonedTask.id
      this.$root.$emit('taskEdit', clonedTask)
    },

    ownerEdit () {
      this.editOwner = true
    },

    updateOwner (event, item) {
      item.owner = event
      this.editOwner = false
      this.updateTask(item)
    },

    updateTask (item) {
      this.textEdit = false
      item.client_id = item.client_object.value
      this.$http.put('/tasks/' + item.id, { task: item })
        .then(response => this.taskSubmitSuccessful(response))
        .catch(e => { console.log(e) })
    },

    taskSubmitSuccessful (response) {
      this.item = response.data
      this.$emit('taskUpdated', response)
    },

    notesExpand () {
      if (event.target.style.whiteSpace === 'normal') {
        event.target.style.whiteSpace = 'nowrap'
      } else {
        event.target.style.whiteSpace = 'normal'
      }
    },
    updatePriority (event, item) {
      item.priority = event
      this.prioritySelect = false
      this.updateTask(item)
    },
    updateTeamNotes: _.debounce(function (item) {
      this.notesEdit = false
      this.updateTask(item)
    }, 2000),
    updateText: _.debounce(function (item) {
      if (item.text.length > 0 && item.text.replace(/\s/g, '') !== '') {
        this.textEdit = false
        this.updateTask(item)
      }
    }, 2000),
    flipStatus (item) {
      item.complete = !item.complete
      delete item.status
      this.updateTask(item)
    },
    updateClient () {
      if (this.item.client_id !== this.item.client_object.value && !(!this.item.client && this.item.client_object.value === null)) {
        this.updateTask(this.item)
      }
      this.clientSelect = false
    },
    updateStatus (event, item) {
      if (event === 'complete') {
        item.complete = true
      }
      item.status = event
      this.editStatus = false
      this.updateTask(item)
    },
    statusColor (data) {
      if (data !== null) {
        data = data.toLowerCase()
        if (data === 'high') {
          return 'red-status-bg'
        } else if (data === 'medium') {
          return 'yellow-status-bg'
        } else if (data === 'low') {
          return 'green-status-bg'
        } else {
          return 'gray-status-bg'
        }
      } else {
        return 'grey-dot'
      }
    },
    fullSelect (item) {
      this.$emit('taskSelected', item)
    }
  },
  watch: {
    task () {
      this.initTask()
    },
    selectedTasks () {
      this.allSelect = this.selectedTasks.includes(this.task)
    }
  }
}
</script>

<style scoped>
.table-notes {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}
.custom-control.custom-checkbox.custom-control-inline {
  margin-right: 0px;
  vertical-align: middle;
  padding-right: 0px;
}
.completed {
  background-color: rgba(245, 245, 245, 1);
  opacity: .5;
}
.red-status-bg {
  background-color: #ca5935de;
}
.green-status-bg {
  background-color: #8BC34A;
}
.yellow-status-bg {
background-color: #FBC02D;
}
.gray-status-bg {
  background-color: #6C757D;
}
.priority-dot {
  height: 25px;
  width: 25px;
  border-radius: 50%;
  margin: 0 auto;
}
.check-section {
  display: flex;
}
.due-date {
  margin-left: 10px;
}
.task-user-logo {
  border-radius: 50%;
  height: 32px;
  width: 32px;
  margin-right: 10px;
}
.task-text-wrapper {
  display: flex;
}
.task-text {
  margin-left: 10px;
}
.table-notes-field {
  display: flex;
}
textarea.form-control {
  width: 80%;
  margin: 0 10px;
}
.card-header {
  display: flex;
  justify-content: space-between;
}
.task-card {
  margin-bottom: 5px;
}
.task-card > .card-body {
  padding: .5rem;
}
.edit-icons {
  color: #000;
  cursor: pointer;
}
.edit-icons:visited {
  color: #000;
}
.item-selected {
  border: 1px solid rgba(0,123,255);
}
.item-selected .card-header {
  background-color: rgba(0,123,255,.3);
  border-bottom: 1px solid rgba(0,123,255);
}
.cp, [data-icon="times-circle"] {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/TaskItem.vue